export const MAX_HEARTS = 5;